import { useLottie } from 'lottie-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import animatedSplash from '../../assets/images/animation-splash.json';
import { useExtendedNavigate } from '../../hooks/useExtendedNavigate';
import useIsMobile from '../../hooks/useIsMobile';
import { useLogScreenViewedEvent } from '../../hooks/useLogScreenViewedEvent';
import { isAuthedSelector } from '../../store/auth';

const AnimationLogo = ({ setFirstLoad }: { setFirstLoad: (p: boolean) => void }) => {
  const navigate = useExtendedNavigate();
  const isAuthed = useSelector(isAuthedSelector);
  const isMobile = useIsMobile();
  useLogScreenViewedEvent('splash');

  const defaultOptions = {
    animationData: animatedSplash,
    autoplay: true,
    loop: false,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid',
    },
  };

  const lottieStyles = !isMobile
    ? { display: 'inline-block', width: '24.94rem' }
    : { display: 'inline-block', width: '18.25rem' };

  const { View } = useLottie(defaultOptions, { ...lottieStyles });

  useEffect(() => {
    setTimeout(() => {
      const currentSearchParams = new URLSearchParams(window.location.search);
      const queryString = currentSearchParams.toString();
      setFirstLoad(false);
      if (isAuthed) {
        navigate(`/home${queryString ? `?${queryString}` : ''}`);
      } else {
        navigate(`/welcome${queryString ? `?${queryString}` : ''}`);
      }
    }, 3500);
  }, []);

  return View;
};

export default AnimationLogo;
